import { render, staticRenderFns } from "./TreatmentsCosts.vue?vue&type=template&id=90cb33fe&scoped=true"
import script from "./TreatmentsCosts.vue?vue&type=script&lang=js"
export * from "./TreatmentsCosts.vue?vue&type=script&lang=js"
import style0 from "./TreatmentsCosts.vue?vue&type=style&index=0&id=90cb33fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cb33fe",
  null
  
)

export default component.exports